import { useSelector } from 'react-redux';
import { useCopy } from 'src/hooks';
import { RootState } from 'src/redux/reducers/rootReducer';

export const useApiMenuItemImpl = () => {
  const apiKeyStaging = useSelector(
    (state: RootState) => state.auth.apiKeyStaging,
  );
  const copy = useCopy();

  const onClickCopyButton = () => {
    if (apiKeyStaging) {
      copy(
        apiKeyStaging,
        'sidebar_apiKeyStagingComponent_toast_success',
        'sidebar_apiKeyStagingComponent_toast_failed',
      );
    }
  };

  return {
    onClickCopyButton,
  };
};
